import axios from 'axios';

const isDev = window.location.port === "3000";
const apiBase = isDev 
  ? `${window.location.protocol}//${window.location.hostname}:8000`
  : `${window.location.protocol}//${window.location.hostname}/api`;

const api = axios.create({
  baseURL: apiBase,
});

// Add a request interceptor to include the JWT token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authApi = {
  login: (credentials) => {
    // FastAPI OAuth2 expects form data, not JSON
    const formData = new URLSearchParams();
    formData.append('username', credentials.username);
    formData.append('password', credentials.password);

    return api.post('/auth/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  },
  register: (userData) => api.post('/auth/register', userData),
};

export const userApi = {
  getUserAnimes: () => api.get('/users/animes'),
  getMe: () => api.get('/users/me'),
  importHistory: (jsonData) => api.post('/history/old_import', jsonData),
  toggleMalSync: (enabled) => api.post(`/users/sync_mal_toggle?enabled=${enabled}`),
  syncMalHistory: () => api.post('/history/sync-mal'),
  importMalHistory: () => api.post('/history/import-mal'),
  getImportStatus: () => api.get('/history/import/status'),
  cancelImport: () => api.post('/history/import/cancel'),
  disconnectMal: () => api.post('/auth/mal/disconnect'),
  checkHealth: () => api.get('/health'),

  // Anime details & deletion
  getAnimeDetails: (animeId) => api.get(`/users/anime/${animeId}`),
  deleteAnimeHistory: (animeId, syncMal = false) => api.delete(`/history/anime/${animeId}?sync_mal=${syncMal}`),
  deleteEpisodeHistory: (animeId, epNum) => api.delete(`/history/episode/${animeId}/${epNum}`),

  // Privacy
  updatePrivacy: (privacyLevel, privacySettings) => api.put('/users/privacy', { privacy_level: privacyLevel, privacy_settings: privacySettings }),
  updateAnimePrivacy: (animeId, privacyLevel) => api.put(`/users/anime/${animeId}/privacy`, { privacy_level: privacyLevel }),
  
  // Franchises
  getFranchiseDetails: (franchiseId) => api.get(`/franchises/${franchiseId}`),
};

export default api;